import * as React from 'react';
import { mergeStyles } from '@cian/utils/lib/shared/style';

const styles = require('./index.css');

interface ICountViewProps {
  children: React.ReactNode;
  className?: string;
}

export const CountView: React.SFC<ICountViewProps> = ({ children, className }) => (
  <div {...mergeStyles(styles['root'], className)}>{children}</div>
);
